import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader  } from '../../Shared/Loader/LoaderSlice';
import { goToPage , setCustomerServiceMessageType } from './ConnectionDetailsBlockSlice';

export const getIspConnectionDetailsAsync = createAsyncThunk('connectionDetailsBlock/getIspConnectionDetails', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().connectionDetailsBlock;
        const request = {ban: state.selectedSubscriber?.ban};
        const result = await ProviderManager.getProviderData('getIspConnectionDetails', request);
        if(result?.Body?.isSuccess) {
            thunkAPI.dispatch(goToPage('connectionDetailsPage'));
        }
        else{
            thunkAPI.dispatch(setCustomerServiceMessageType('ERROR'));
            thunkAPI.dispatch(goToPage('customerServiceMessagesPage'));
        }
        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(setCustomerServiceMessageType('ERROR'));
        thunkAPI.dispatch(goToPage('customerServiceMessagesPage'));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});
